import { Types } from "../actions/auth";

const INITIAL_STATE = {
  isAuth: false || window.localStorage.getItem("auth") === "true",
  token: window.localStorage.getItem("token")
    ? window.localStorage.getItem("token")
    : "",
  isAdmin: false || window.localStorage.getItem("isAdmin") === "true",
  isOneFactor: false,
};

export default function auth(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.SET_AUTH: {
      return {
        ...state,
        isAuth: action.payload.isAuth,
      };
    }
    case Types.SET_TOKEN: {
      return {
        ...state,
        token: action.payload.token,
      };
    }
    case Types.SET_ADMIN: {
      return {
        ...state,
        isAdmin: action.payload.isAdmin,
      };
    }
    case Types.SET_ONE_FACTOR: {
      return {
        ...state,
        isOneFactor: action.payload.isOneFactor,
      };
    }
    default: {
      return state;
    }
  }
}
